import useScriptFlag from '@/hooks/useScriptFlag';
import Script from 'next/script';

export default function AdMembrana() {
  const shouldRenderAds = useScriptFlag({ adFlag: 'membrana' });

  return shouldRenderAds ? (
    <div id="CLT_VIDEO_DIV" className="CLT_VIDEO">
      <Script async src="https://cdn.membrana.media/clt/ym.js"></Script>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            window.yieldMasterCmd = window.yieldMasterCmd || [];
            window.yieldMasterCmd.push(function () {
              window.yieldMaster.init({
                pageVersionAutodetect: true,
              });
            });
      `,
        }}
      />
    </div>
  ) : null;
}
